import Swiper, { Navigation } from 'swiper';
// https://medium.com/@networkaaron/swiper-how-to-destroy-swiper-on-min-width-breakpoints-a947491ddec8
const breakpoint = window.matchMedia( '(max-width: 1199px)' );
let mySwiper;
const breakpointChecker = function() {
  if ( breakpoint.matches === true ) {
    if ( mySwiper !== undefined ) {
      document.querySelector('.swiper').swiper.destroy();
    };
    return;
  } else if ( breakpoint.matches === false ) {
    return enableSwiper();
  }
};
const enableSwiper = function() {
  mySwiper = new Swiper ('.swiper', {
    modules: [Navigation],
    loop: true,
    autoHeight: true,
    slidesPerView: 3,
    spaceBetween: 30,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
};
breakpoint.addListener(breakpointChecker);
breakpointChecker();
